import React from 'react';
interface WavyBackgroundProps {
  className?: string;
  color?: string;
  opacity?: number;
}
const WavyBackground = ({
  className = '',
  color = '#7091E6',
  opacity = 0.1
}: WavyBackgroundProps) => {
  return <div className={`absolute w-full overflow-hidden ${className}`} data-id="element-569">
      <svg className="animate-wave" viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
      width: '200%',
      height: '100%'
    }} data-id="element-570">
        <path d="M0,60 C240,120 480,0 720,60 C960,120 1200,0 1440,60 L1440,120 L0,120 Z" fill={color} fillOpacity={opacity} data-id="element-571" />
      </svg>
    </div>;
};
export default WavyBackground;